import { FilterDef } from "@/stores/filters/FilterDef";
import { FilterParamValue } from "@/stores/filters/FilterParamValue.ts";

export class LessonPlanFilterDef extends FilterDef {

	/**
	 * Constructor
	 */
	constructor() {

		super([
			// 'activityTags',
			// 'themeTags',
			'goals',
			'keywords',
			'collections',
		]);

	}

	set collectionIds(collectionIds: string[]) {
		this.setParamValues('collections', collectionIds.map(id => new FilterParamValue(id, id)));
	}

	get collectionIds(): string[] {
		return this.getParamValues('collections').map(v => v.id.toString());
	}

}
